/* Options:
Date: 2026-03-13 15:51:07
Version: 6.2
Tip: To override a DTO option, remove "//" prefix before updating
BaseUrl: https://localhost:7289

//GlobalNamespace: 
MakePropertiesOptional: True
//AddServiceStackTypes: True
//AddResponseStatus: False
//AddImplicitVersion: 
//AddDescriptionAsComments: True
//IncludeTypes: 
//ExcludeTypes: 
DefaultImports: immerable:immer
*/

import { immerable } from "immer";

export interface IReturn<T>
{
    createResponse(): T;
}

export interface IReturnVoid
{
    createResponse(): void;
}

export interface IGet
{
}

export interface IPost
{
}

export interface IDelete
{
}

export enum Speciality
{
    Medical_Oncologist = 1,
    Surgeon_or_Surgical_Oncologist = 2,
    Study_Coordinator_or_Research_Nurse = 3,
    Radiation_Oncologist = 4,
    Pathologist = 5,
    Statistician = 6,
    Breast_Physician = 8,
    Radiologist = 11,
    Endocrinologist = 12,
    Geneticist = 13,
    Haematologist = 14,
    Psycho_oncology_or_Quality_of_Life_or_Psychology = 16,
    Basic_Scientist = 17,
    Consumer_Advocacy = 18,
    BCT_Staff = 19,
    General_Practitioner = 20,
    Gynaecologist = 21,
    Pharmaceutical = 22,
}

export enum YesNo
{
    No = 0,
    Yes = 1,
}

export enum MembershipType
{
    Full_Member = 1,
    Affiliate_Member = 2,
}

export class ResearchApplication implements IForm
{
    [immerable] = true;
    public repeat?: number;
    public id?: number;
    public title?: number;
    public firstName?: string;
    public lastName?: string;
    public institution?: string;
    public address?: string;
    public country?: number;
    public state?: number;
    public suburb?: string;
    public postcode?: string;
    public phone?: string;
    public fax?: string;
    public mobile?: string;
    public email?: string;
    public speciality?: Speciality;
    public specifySpec?: string;
    public trainee?: boolean;
    public additionalSpecialities?: string[];
    public higherDegree?: YesNo;
    public degreeType?: string;
    public yearAwarded?: number;
    public interestPeerReview?: YesNo;
    public interestConceptDevelopment?: YesNo;
    public otherInterests?: OtherInterests[];
    public otherInterestSpecify?: string;
    public involvement?: string;
    public reason?: string;
    public membershipTypeId?: MembershipType;
    public noSupporters?: boolean;
    public proposer?: string;
    public proposerId?: string;
    public seconder?: string;
    public seconderId?: string;
    public emailPermission?: YesNo;
    public websitePermission?: YesNo;
    public idealsConsent?: boolean;
    public constitutionConsent?: boolean;
    public lawAcknowledgement?: boolean;
    public enteredDate?: string;
    public enteredBy?: string;
    public modifiedDate?: string;
    public modifiedBy?: string;
    public parentFormDefinitionId?: number;
    public parentFormId?: number;

    public constructor(init?: Partial<ResearchApplication>) { (Object as any).assign(this, init); }
}

export interface IUserGetSingle
{
    metadata?: { [index: string]: Object; };
}

export interface ILookupGetCollectionByFormDefinitionId extends IGet
{
    formDefinitionId?: number;
}

export interface IConfigurationGetSingleById extends IGet
{
    id?: number;
}

export interface IConfigurationGetCollection extends IGet
{
    skip?: number;
    take?: number;
}

export interface IConfigurationGetSingleByCode extends IGet
{
    code?: string;
}

export interface IDataGetSingleById extends IGet
{
    id?: number;
}

export interface IDataGetCollection extends IGet
{
    skip?: number;
    take?: number;
}

// @DataContract
export class ResponseError
{
    [immerable] = true;
    // @DataMember(Order=1)
    public errorCode?: string;

    // @DataMember(Order=2)
    public fieldName?: string;

    // @DataMember(Order=3)
    public message?: string;

    // @DataMember(Order=4)
    public meta?: { [index: string]: string; };

    public constructor(init?: Partial<ResponseError>) { (Object as any).assign(this, init); }
}

// @DataContract
export class ResponseStatus
{
    [immerable] = true;
    // @DataMember(Order=1)
    public errorCode?: string;

    // @DataMember(Order=2)
    public message?: string;

    // @DataMember(Order=3)
    public stackTrace?: string;

    // @DataMember(Order=4)
    public errors?: ResponseError[];

    // @DataMember(Order=5)
    public meta?: { [index: string]: string; };

    public constructor(init?: Partial<ResponseStatus>) { (Object as any).assign(this, init); }
}

export class SentrySettings
{
    [immerable] = true;
    public dsn?: string;
    public environment?: string;
    public customer?: string;
    public sendDefaultPii?: boolean;
    public enableMetrics?: boolean;
    public attachStacktrace?: boolean;
    public debug?: boolean;
    public enableLogs?: boolean;
    public enableReportABug?: boolean;
    public replaysOnErrorSampleRate?: number;
    public replaysSessionSampleRate?: number;
    public tracesSampleRate?: number;

    public constructor(init?: Partial<SentrySettings>) { (Object as any).assign(this, init); }
}

export class ClientAppSettings
{
    [immerable] = true;
    public sentry?: SentrySettings;

    public constructor(init?: Partial<ClientAppSettings>) { (Object as any).assign(this, init); }
}

export class ServerStats
{
    [immerable] = true;
    public redis?: { [index: string]: number; };
    public serverEvents?: { [index: string]: string; };
    public mqDescription?: string;
    public mqWorkers?: { [index: string]: number; };

    public constructor(init?: Partial<ServerStats>) { (Object as any).assign(this, init); }
}

export class RequestLogEntry
{
    [immerable] = true;
    public id?: number;
    public traceId?: string;
    public operationName?: string;
    public dateTime?: string;
    public statusCode?: number;
    public statusDescription?: string;
    public httpMethod?: string;
    public absoluteUri?: string;
    public pathInfo?: string;
    // @StringLength(2147483647)
    public requestBody?: string;

    public requestDto?: Object;
    public userAuthId?: string;
    public sessionId?: string;
    public ipAddress?: string;
    public forwardedFor?: string;
    public referer?: string;
    public headers?: { [index: string]: string; };
    public formData?: { [index: string]: string; };
    public items?: { [index: string]: string; };
    public responseHeaders?: { [index: string]: string; };
    public session?: Object;
    public responseDto?: Object;
    public errorResponse?: Object;
    public exceptionSource?: string;
    public exceptionData?: any;
    public requestDuration?: string;
    public meta?: { [index: string]: string; };

    public constructor(init?: Partial<RequestLogEntry>) { (Object as any).assign(this, init); }
}

export class DiagnosticEntry
{
    [immerable] = true;
    public id?: number;
    public traceId?: string;
    public source?: string;
    public eventType?: string;
    public message?: string;
    public operation?: string;
    public threadId?: number;
    public error?: ResponseStatus;
    public commandType?: string;
    public command?: string;
    public userAuthId?: string;
    public sessionId?: string;
    public arg?: string;
    public args?: string[];
    public argLengths?: number[];
    public namedArgs?: { [index: string]: Object; };
    public duration?: string;
    public timestamp?: number;
    public date?: string;
    public tag?: string;
    public stackTrace?: string;
    public meta?: { [index: string]: string; };

    public constructor(init?: Partial<DiagnosticEntry>) { (Object as any).assign(this, init); }
}

export interface IFileUploadTemporary
{
    guid?: string;
    name?: string;
    extension?: string;
    fileSize?: number;
    contentType?: string;
    image?: boolean;
}

export class User implements IUserDto
{
    [immerable] = true;
    public userId?: string;
    public userName?: string;
    public displayName?: string;
    public sessionId?: string;

    public constructor(init?: Partial<User>) { (Object as any).assign(this, init); }
}

export class LookupItem
{
    [immerable] = true;
    public id?: number;
    public value?: string;
    public order?: number;

    public constructor(init?: Partial<LookupItem>) { (Object as any).assign(this, init); }
}

export class Lookup
{
    [immerable] = true;
    public propertyName?: string;
    public items?: LookupItem[];

    public constructor(init?: Partial<Lookup>) { (Object as any).assign(this, init); }
}

export class FormMetadata
{
    [immerable] = true;
    public formDefinitionId?: number;
    public formDefinitionCode?: string;
    public name?: string;
    public propertyName?: string;
    public title?: string;
    public instructions?: string;

    public constructor(init?: Partial<FormMetadata>) { (Object as any).assign(this, init); }
}

export class FormType implements IFormType
{
    [immerable] = true;
    public id?: number;
    public code?: string;
    public name?: string;

    public constructor(init?: Partial<FormType>) { (Object as any).assign(this, init); }
}

export enum ValidationErrorType
{
    Warning = 1,
    Low = 2,
    Normal = 3,
    High = 4,
    Critical = 5,
}

export class FormDefinitionPropertyErrorMessage implements IFormDefinitionPropertyErrorMessage
{
    [immerable] = true;
    public id?: number;
    // @References("typeof(NewtonGreen.ServiceStack.Forms.Models.Configuration.FormDefinitionProperty)")
    public formDefinitionPropertyId?: number;

    public errorCode?: string;
    public message?: string;
    public detailedMessage?: string;
    public type?: ValidationErrorType;

    public constructor(init?: Partial<FormDefinitionPropertyErrorMessage>) { (Object as any).assign(this, init); }
}

export class FormDefinitionProperty
{
    [immerable] = true;
    public id?: number;
    // @References("typeof(NewtonGreen.ServiceStack.Forms.Models.Configuration.FormDefinition)")
    public formDefinitionId?: number;

    public propertyName?: string;
    public label?: string;
    public detailedLabel?: string;
    public errorMessages?: FormDefinitionPropertyErrorMessage[];

    public constructor(init?: Partial<FormDefinitionProperty>) { (Object as any).assign(this, init); }
}

export class FormDefinition
{
    [immerable] = true;
    public id?: number;
    public code?: string;
    public type?: number;
    public name?: string;
    public instructions?: string;
    public patientInstructions?: string;
    public properties?: FormDefinitionProperty[];
    // @Ignore()
    public subformProperties?: { [index: string]: FormDefinitionProperty[]; };

    public constructor(init?: Partial<FormDefinition>) { (Object as any).assign(this, init); }
}

export enum ValidationResultType
{
    Valid = 1,
    Low = 2,
    Normal = 3,
    High = 4,
    Critical = 5,
}

export class ValidationError implements IValidationError
{
    [immerable] = true;
    public property?: string;
    public message?: string;
    public detailedMessage?: string;
    public code?: string;
    public ruleSet?: string;
    public type?: ValidationErrorType;

    public constructor(init?: Partial<ValidationError>) { (Object as any).assign(this, init); }
}

export class ValidationResult
{
    [immerable] = true;
    public result?: ValidationResultType;
    public errors?: ValidationError[];
    public metadata?: { [index: string]: Object; };

    public constructor(init?: Partial<ValidationResult>) { (Object as any).assign(this, init); }
}

export enum OtherInterests
{
    Basic_Science = 1,
    Biostatistics = 2,
    Bone_health = 3,
    Bone_metastases = 4,
    Brain_metastases = 5,
    Breast_cancer_prevention = 6,
    Breast_reconstruction = 7,
    Cardiac_health = 8,
    ctDNA_circulating_tumour_cells = 9,
    DCIS = 10,
    Endocrinetherapy = 11,
    Epidemiology = 12,
    Familial_cancer_genetics = 13,
    Fertility = 14,
    Health_economics = 15,
    Health_services_research = 16,
    HER2_positive_disease = 17,
    Imaging_screening = 18,
    Immunotherapy = 19,
    Implementation_research = 20,
    Lifestyle_interventions = 21,
    Locoregional_clinical_trials = 22,
    Menopause = 23,
    Metastatic_disease = 24,
    Neoadjuvant_trials = 25,
    Next_Generation_Sequencing = 26,
    Older_patients = 27,
    Palliative_care = 28,
    Pathology = 29,
    Patient_reported_outcomes_or_quality_of_life = 30,
    Psychooncology = 31,
    Public_health_research = 32,
    Radiation_research = 33,
    Stereotactic_radiation = 34,
    Supportive_care = 35,
    Surgical_trials = 36,
    Survivorship = 37,
    Translational_Research = 38,
    Triple_Negative_Breast_Cancer = 39,
    Young_patients = 40,
    Other = 41,
}

export interface IForm extends IDataModel, IHasParentFormDefinitionId, IHasParentFormId
{
    repeat?: number;
}

export interface IDataModel extends IModel, IHasAudit
{
}

export interface IModel
{
    id?: number;
}

export interface IHasAudit
{
    enteredDate?: string;
    enteredBy?: string;
    modifiedDate?: string;
    modifiedBy?: string;
}

export interface IHasParentFormDefinitionId
{
    parentFormDefinitionId?: number;
}

export interface IHasParentFormId
{
    parentFormId?: number;
}

export interface IUserDto
{
    userId?: string;
    userName?: string;
    displayName?: string;
    sessionId?: string;
}

export interface ILookupItem
{
    id?: Object;
    value?: Object;
    order?: Object;
}

export interface ILookup
{
    propertyName?: string;
    items?: ILookupItem[];
}

export interface IFormType extends IConfigurationModel, IHasCode
{
    name?: string;
}

export interface IConfigurationModel extends IModel
{
}

export interface IHasCode
{
    code?: string;
}

export interface IFormDefinitionPropertyErrorMessage extends IConfigurationModel, IHasFormDefinitionPropertyId
{
    errorCode?: string;
    message?: string;
    detailedMessage?: string;
    type?: ValidationErrorType;
}

export interface IFormDefinitionProperty extends IConfigurationModel, IHasFormDefinitionId
{
    propertyName?: string;
    label?: string;
    detailedLabel?: string;
    errorMessages?: IFormDefinitionPropertyErrorMessage[];
}

export interface IFormDefinition extends IConfigurationModel, IHasCode
{
    type?: number;
    name?: string;
    instructions?: string;
    properties?: IFormDefinitionProperty[];
    subformProperties?: { [index: string]: IFormDefinitionProperty[]; };
}

export interface IValidationError
{
    property?: string;
    message?: string;
    detailedMessage?: string;
    code?: string;
    type?: ValidationErrorType;
}

export interface IValidationResult
{
    metadata?: { [index: string]: Object; };
    result?: ValidationResultType;
    errors?: IValidationError[];
}

export interface IHasFormDefinitionId
{
    formDefinitionId?: number;
}

export interface IHasFormDefinitionPropertyId
{
    formDefinitionPropertyId?: number;
}

export class PostApplicationResponse
{
    [immerable] = true;
    public responseStatus?: ResponseStatus;

    public constructor(init?: Partial<PostApplicationResponse>) { (Object as any).assign(this, init); }
}

export class throwfakeResponse
{
    [immerable] = true;
    public responseStatus?: ResponseStatus;

    public constructor(init?: Partial<throwfakeResponse>) { (Object as any).assign(this, init); }
}

export class GetClientAppSettingsResponse
{
    [immerable] = true;
    public settings?: ClientAppSettings;
    public responseStatus?: ResponseStatus;

    public constructor(init?: Partial<GetClientAppSettingsResponse>) { (Object as any).assign(this, init); }
}

export class PostIsSupporterResponse
{
    [immerable] = true;
    public responseStatus?: ResponseStatus;
    public id?: string;

    public constructor(init?: Partial<PostIsSupporterResponse>) { (Object as any).assign(this, init); }
}

export class AdminDashboardResponse
{
    [immerable] = true;
    public serverStats?: ServerStats;
    public responseStatus?: ResponseStatus;

    public constructor(init?: Partial<AdminDashboardResponse>) { (Object as any).assign(this, init); }
}

// @DataContract
export class RequestLogsResponse
{
    [immerable] = true;
    // @DataMember(Order=1)
    public results?: RequestLogEntry[];

    // @DataMember(Order=2)
    public usage?: { [index: string]: string; };

    // @DataMember(Order=3)
    public total?: number;

    // @DataMember(Order=4)
    public responseStatus?: ResponseStatus;

    public constructor(init?: Partial<RequestLogsResponse>) { (Object as any).assign(this, init); }
}

export class AdminProfilingResponse
{
    [immerable] = true;
    public results?: DiagnosticEntry[];
    public total?: number;
    public responseStatus?: ResponseStatus;

    public constructor(init?: Partial<AdminProfilingResponse>) { (Object as any).assign(this, init); }
}

export class UploadResponse
{
    [immerable] = true;
    public responseStatus?: ResponseStatus;
    public upload?: IFileUploadTemporary;

    public constructor(init?: Partial<UploadResponse>) { (Object as any).assign(this, init); }
}

// @DataContract
export class UserSingleResponse
{
    [immerable] = true;
    /**
    * The information about any issues that may have occurred while attempting to process the request.
    */
    // @DataMember(Order=1)
    public responseStatus?: ResponseStatus;

    /**
    * The retrieved user.
    */
    // @DataMember(Order=2)
    public user?: User;

    public constructor(init?: Partial<UserSingleResponse>) { (Object as any).assign(this, init); }
}

// @DataContract
export class LookupCollectionResponse
{
    [immerable] = true;
    /**
    * The information about any issues that may have occurred while attempting to process the request.
    */
    // @DataMember(Order=1)
    public responseStatus?: ResponseStatus;

    /**
    * The retrieved lookups.
    */
    // @DataMember(Order=2)
    public lookups?: Lookup[];

    public constructor(init?: Partial<LookupCollectionResponse>) { (Object as any).assign(this, init); }
}

export class GetFormMetadataResponse
{
    [immerable] = true;
    public responseStatus?: ResponseStatus;
    public formMetadata?: FormMetadata[];

    public constructor(init?: Partial<GetFormMetadataResponse>) { (Object as any).assign(this, init); }
}

// @DataContract
export class FormTypeSingleResponse
{
    [immerable] = true;
    /**
    * The information about any issues that may have occurred while attempting to process the request.
    */
    // @DataMember(Order=1)
    public responseStatus?: ResponseStatus;

    /**
    * The retrieved form type.
    */
    // @DataMember(Order=2)
    public configuration?: FormType;

    public constructor(init?: Partial<FormTypeSingleResponse>) { (Object as any).assign(this, init); }
}

// @DataContract
export class FormTypeCollectionResponse
{
    [immerable] = true;
    /**
    * The information about any issues that may have occurred while attempting to process the request.
    */
    // @DataMember(Order=1)
    public responseStatus?: ResponseStatus;

    /**
    * The retrieved form types.
    */
    // @DataMember(Order=2)
    public configuration?: FormType[];

    public constructor(init?: Partial<FormTypeCollectionResponse>) { (Object as any).assign(this, init); }
}

// @DataContract
export class FormDefinitionSingleResponse
{
    [immerable] = true;
    /**
    * The information about any issues that may have occurred while attempting to process the request.
    */
    // @DataMember(Order=1)
    public responseStatus?: ResponseStatus;

    /**
    * The retrieved form definition.
    */
    // @DataMember(Order=2)
    public configuration?: FormDefinition;

    public constructor(init?: Partial<FormDefinitionSingleResponse>) { (Object as any).assign(this, init); }
}

// @DataContract
export class FormDefinitionCollectionResponse
{
    [immerable] = true;
    /**
    * The information about any issues that may have occurred while attempting to process the request.
    */
    // @DataMember(Order=1)
    public responseStatus?: ResponseStatus;

    /**
    * The retrieved form definitions.
    */
    // @DataMember(Order=2)
    public configuration?: FormDefinition[];

    public constructor(init?: Partial<FormDefinitionCollectionResponse>) { (Object as any).assign(this, init); }
}

// @DataContract
export class ResearchApplicationSingleResponse
{
    [immerable] = true;
    /**
    * The information about any issues that may have occurred while attempting to process the request.
    */
    // @DataMember(Order=1)
    public responseStatus?: ResponseStatus;

    /**
    * The retrieved research application.
    */
    // @DataMember(Order=2)
    public data?: ResearchApplication;

    public constructor(init?: Partial<ResearchApplicationSingleResponse>) { (Object as any).assign(this, init); }
}

// @DataContract
export class ResearchApplicationCollectionResponse
{
    [immerable] = true;
    /**
    * The information about any issues that may have occurred while attempting to process the request.
    */
    // @DataMember(Order=1)
    public responseStatus?: ResponseStatus;

    /**
    * The retrieved research applications.
    */
    // @DataMember(Order=2)
    public data?: ResearchApplication[];

    public constructor(init?: Partial<ResearchApplicationCollectionResponse>) { (Object as any).assign(this, init); }
}

// @DataContract
export class ResearchApplicationValidationResponse
{
    [immerable] = true;
    /**
    * The information about any issues that may have occurred while attempting to process the request.
    */
    // @DataMember(Order=1)
    public responseStatus?: ResponseStatus;

    /**
    * The validation result.
    */
    // @DataMember(Order=2)
    public validationResult?: ValidationResult;

    public constructor(init?: Partial<ResearchApplicationValidationResponse>) { (Object as any).assign(this, init); }
}

export class PostApplication implements IReturn<PostApplicationResponse>, IPost
{
    [immerable] = true;
    public application?: ResearchApplication;

    public constructor(init?: Partial<PostApplication>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'PostApplication'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new PostApplicationResponse(); }
}

export class throwfake implements IReturn<throwfakeResponse>, IPost
{
    [immerable] = true;

    public constructor(init?: Partial<throwfake>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'throwfake'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new throwfakeResponse(); }
}

export class GetClientAppSettings implements IReturn<GetClientAppSettingsResponse>
{
    [immerable] = true;

    public constructor(init?: Partial<GetClientAppSettings>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GetClientAppSettings'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new GetClientAppSettingsResponse(); }
}

export class PostIsSupporter implements IReturn<PostIsSupporterResponse>, IPost
{
    [immerable] = true;
    public name?: string;

    public constructor(init?: Partial<PostIsSupporter>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'PostIsSupporter'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new PostIsSupporterResponse(); }
}

export class AdminDashboard implements IReturn<AdminDashboardResponse>
{
    [immerable] = true;

    public constructor(init?: Partial<AdminDashboard>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'AdminDashboard'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new AdminDashboardResponse(); }
}

// @Route("/requestlogs")
// @DataContract
export class RequestLogs implements IReturn<RequestLogsResponse>
{
    [immerable] = true;
    // @DataMember(Order=1)
    public beforeSecs?: number;

    // @DataMember(Order=2)
    public afterSecs?: number;

    // @DataMember(Order=3)
    public operationName?: string;

    // @DataMember(Order=4)
    public ipAddress?: string;

    // @DataMember(Order=5)
    public forwardedFor?: string;

    // @DataMember(Order=6)
    public userAuthId?: string;

    // @DataMember(Order=7)
    public sessionId?: string;

    // @DataMember(Order=8)
    public referer?: string;

    // @DataMember(Order=9)
    public pathInfo?: string;

    // @DataMember(Order=10)
    public ids?: number[];

    // @DataMember(Order=11)
    public beforeId?: number;

    // @DataMember(Order=12)
    public afterId?: number;

    // @DataMember(Order=13)
    public hasResponse?: boolean;

    // @DataMember(Order=14)
    public withErrors?: boolean;

    // @DataMember(Order=15)
    public enableSessionTracking?: boolean;

    // @DataMember(Order=16)
    public enableResponseTracking?: boolean;

    // @DataMember(Order=17)
    public enableErrorTracking?: boolean;

    // @DataMember(Order=18)
    public durationLongerThan?: string;

    // @DataMember(Order=19)
    public durationLessThan?: string;

    // @DataMember(Order=20)
    public skip?: number;

    // @DataMember(Order=21)
    public take?: number;

    // @DataMember(Order=22)
    public orderBy?: string;

    public constructor(init?: Partial<RequestLogs>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'RequestLogs'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new RequestLogsResponse(); }
}

export class AdminProfiling implements IReturn<AdminProfilingResponse>
{
    [immerable] = true;
    public source?: string;
    public eventType?: string;
    public threadId?: number;
    public traceId?: string;
    public userAuthId?: string;
    public sessionId?: string;
    public tag?: string;
    public skip?: number;
    public take?: number;
    public orderBy?: string;
    public withErrors?: boolean;
    public pending?: boolean;

    public constructor(init?: Partial<AdminProfiling>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'AdminProfiling'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new AdminProfilingResponse(); }
}

// @Route("/research-member-application/file-upload", "POST")
export class PostUploadFile implements IReturn<UploadResponse>, IPost
{
    [immerable] = true;

    public constructor(init?: Partial<PostUploadFile>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'PostUploadFile'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new UploadResponse(); }
}

// @Route("/research-member-application/file-upload/info/{Guid}", "GET")
export class GetUploadInfo implements IReturn<UploadResponse>, IGet
{
    [immerable] = true;
    public guid?: string;

    public constructor(init?: Partial<GetUploadInfo>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GetUploadInfo'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new UploadResponse(); }
}

// @Route("/research-member-application/file-upload/{Guid}", "GET")
export class GetUpload implements IReturn<Blob>, IGet
{
    [immerable] = true;
    public guid?: string;

    public constructor(init?: Partial<GetUpload>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GetUpload'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new Blob(); }
}

// @Route("/research-member-application/file-upload/download/{Guid}", "GET")
export class DownloadUpload implements IReturn<Blob>, IGet
{
    [immerable] = true;
    public guid?: string;

    public constructor(init?: Partial<DownloadUpload>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'DownloadUpload'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new Blob(); }
}

// @Route("/research-member-application/file-upload/{Guid}", "DELETE")
export class DeleteUpload implements IReturn<UploadResponse>, IDelete
{
    [immerable] = true;
    public guid?: string;

    public constructor(init?: Partial<DeleteUpload>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'DeleteUpload'; }
    public getMethod() { return 'DELETE'; }
    public createResponse() { return new UploadResponse(); }
}

/**
* User
*/
// @Route("/research-member-application/user/single/user", "GET")
// @Api(Description="User")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Forms.User.UserSingleResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Forms.User.UserSingleResponse)", StatusCode=403)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Forms.User.UserSingleResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Forms.User.UserSingleResponse)", StatusCode=500)
// @DataContract
export class UserGetSingle implements IReturn<UserSingleResponse>, IUserGetSingle
{
    [immerable] = true;
    /**
    * The metadata of the request.
    */
    // @DataMember(Order=1)
    public metadata?: { [index: string]: Object; };

    public constructor(init?: Partial<UserGetSingle>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'UserGetSingle'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new UserSingleResponse(); }
}

/**
* Lookup
*/
// @Route("/research-member-application/lookup/collection/form-definition/{FormDefinitionId}", "GET")
// @Api(Description="Lookup")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Forms.Lookup.LookupCollectionResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Forms.Lookup.LookupCollectionResponse)", StatusCode=403)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Forms.Lookup.LookupCollectionResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Forms.Lookup.LookupCollectionResponse)", StatusCode=500)
// @DataContract
export class LookupGetCollectionByFormDefinitionId implements IReturn<LookupCollectionResponse>, ILookupGetCollectionByFormDefinitionId
{
    [immerable] = true;
    /**
    * The ID of the Form Definition associated with the lookup to retrieve.
    */
    // @DataMember(Order=1)
    public formDefinitionId?: number;

    public constructor(init?: Partial<LookupGetCollectionByFormDefinitionId>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'LookupGetCollectionByFormDefinitionId'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new LookupCollectionResponse(); }
}

// @Route("/research-member-application/form-names", "GET")
export class GetFormMetadata implements IReturn<GetFormMetadataResponse>
{
    [immerable] = true;

    public constructor(init?: Partial<GetFormMetadata>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GetFormMetadata'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new GetFormMetadataResponse(); }
}

/**
* Form Type
*/
// @Route("/research-member-application/form-type/single/id/{Id}", "GET")
// @Api(Description="Form Type")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Forms.FormType.FormTypeSingleResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Forms.FormType.FormTypeSingleResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Forms.FormType.FormTypeSingleResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Forms.FormType.FormTypeSingleResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Forms.FormType.FormTypeSingleResponse)", StatusCode=500)
// @DataContract
export class FormTypeGetSingleById implements IReturn<FormTypeSingleResponse>, IConfigurationGetSingleById
{
    [immerable] = true;
    /**
    * The ID of the form type to retrieve.
    */
    // @DataMember(Order=1)
    public id?: number;

    public constructor(init?: Partial<FormTypeGetSingleById>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'FormTypeGetSingleById'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new FormTypeSingleResponse(); }
}

/**
* Form Type
*/
// @Route("/research-member-application/form-type/collection", "GET")
// @Api(Description="Form Type")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Forms.FormType.FormTypeCollectionResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Forms.FormType.FormTypeCollectionResponse)", StatusCode=403)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Forms.FormType.FormTypeCollectionResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Forms.FormType.FormTypeCollectionResponse)", StatusCode=500)
// @DataContract
export class FormTypeGetCollection implements IReturn<FormTypeCollectionResponse>, IConfigurationGetCollection
{
    [immerable] = true;
    /**
    * The number of entries to skip.
    */
    // @DataMember(Order=1)
    public skip?: number;

    /**
    * The number of entries to return.
    */
    // @DataMember(Order=2)
    public take?: number;

    public constructor(init?: Partial<FormTypeGetCollection>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'FormTypeGetCollection'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new FormTypeCollectionResponse(); }
}

/**
* Form Type
*/
// @Route("/research-member-application/form-type/single/code/{Code}", "GET")
// @Api(Description="Form Type")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Forms.FormType.FormTypeSingleResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Forms.FormType.FormTypeSingleResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Forms.FormType.FormTypeSingleResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Forms.FormType.FormTypeSingleResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Forms.FormType.FormTypeSingleResponse)", StatusCode=500)
// @DataContract
export class FormTypeGetSingleByCode implements IReturn<FormTypeSingleResponse>, IConfigurationGetSingleByCode
{
    [immerable] = true;
    /**
    * The ID of the form type to retrieve.
    */
    // @DataMember(Order=1)
    public code?: string;

    public constructor(init?: Partial<FormTypeGetSingleByCode>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'FormTypeGetSingleByCode'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new FormTypeSingleResponse(); }
}

/**
* Form Definition
*/
// @Route("/research-member-application/form-definition/single/id/{Id}", "GET")
// @Api(Description="Form Definition")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Forms.FormDefinition.FormDefinitionSingleResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Forms.FormDefinition.FormDefinitionSingleResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Forms.FormDefinition.FormDefinitionSingleResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Forms.FormDefinition.FormDefinitionSingleResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Forms.FormDefinition.FormDefinitionSingleResponse)", StatusCode=500)
// @DataContract
export class FormDefinitionGetSingleById implements IReturn<FormDefinitionSingleResponse>, IConfigurationGetSingleById
{
    [immerable] = true;
    /**
    * The ID of the form definition to retrieve.
    */
    // @DataMember(Order=1)
    public id?: number;

    public constructor(init?: Partial<FormDefinitionGetSingleById>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'FormDefinitionGetSingleById'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new FormDefinitionSingleResponse(); }
}

/**
* Form Definition
*/
// @Route("/research-member-application/form-definition/collection", "GET")
// @Api(Description="Form Definition")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Forms.FormDefinition.FormDefinitionCollectionResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Forms.FormDefinition.FormDefinitionCollectionResponse)", StatusCode=403)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Forms.FormDefinition.FormDefinitionCollectionResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Forms.FormDefinition.FormDefinitionCollectionResponse)", StatusCode=500)
// @DataContract
export class FormDefinitionGetCollection implements IReturn<FormDefinitionCollectionResponse>, IConfigurationGetCollection
{
    [immerable] = true;
    /**
    * The number of entries to skip.
    */
    // @DataMember(Order=1)
    public skip?: number;

    /**
    * The number of entries to return.
    */
    // @DataMember(Order=2)
    public take?: number;

    public constructor(init?: Partial<FormDefinitionGetCollection>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'FormDefinitionGetCollection'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new FormDefinitionCollectionResponse(); }
}

/**
* Form Definition
*/
// @Route("/research-member-application/form-definition/single/code/{Code}", "GET")
// @Api(Description="Form Definition")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Forms.FormDefinition.FormDefinitionSingleResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Forms.FormDefinition.FormDefinitionSingleResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Forms.FormDefinition.FormDefinitionSingleResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Forms.FormDefinition.FormDefinitionSingleResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Forms.FormDefinition.FormDefinitionSingleResponse)", StatusCode=500)
// @DataContract
export class FormDefinitionGetSingleByCode implements IReturn<FormDefinitionSingleResponse>, IConfigurationGetSingleByCode
{
    [immerable] = true;
    /**
    * The ID of the form definition to retrieve.
    */
    // @DataMember(Order=1)
    public code?: string;

    public constructor(init?: Partial<FormDefinitionGetSingleByCode>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'FormDefinitionGetSingleByCode'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new FormDefinitionSingleResponse(); }
}

/**
* Form - ResearchApplication
*/
// @Route("/research-member-application/form/research-application/single/id/{Id}", "GET")
// @Api(Description="Form - ResearchApplication")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Forms.Form.ResearchApplicationSingleResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Forms.Form.ResearchApplicationSingleResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Forms.Form.ResearchApplicationSingleResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Forms.Form.ResearchApplicationSingleResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Forms.Form.ResearchApplicationSingleResponse)", StatusCode=500)
// @DataContract
export class ResearchApplicationGetSingleById implements IReturn<ResearchApplicationSingleResponse>, IDataGetSingleById
{
    [immerable] = true;
    /**
    * The ID of the research application to retrieve.
    */
    // @DataMember(Order=1)
    public id?: number;

    public constructor(init?: Partial<ResearchApplicationGetSingleById>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'ResearchApplicationGetSingleById'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new ResearchApplicationSingleResponse(); }
}

/**
* Form - ResearchApplication
*/
// @Route("/research-member-application/form/research-application/collection", "GET")
// @Api(Description="Form - ResearchApplication")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Forms.Form.ResearchApplicationCollectionResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Forms.Form.ResearchApplicationCollectionResponse)", StatusCode=403)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Forms.Form.ResearchApplicationCollectionResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Forms.Form.ResearchApplicationCollectionResponse)", StatusCode=500)
// @DataContract
export class ResearchApplicationGetCollection implements IReturn<ResearchApplicationCollectionResponse>, IDataGetCollection
{
    [immerable] = true;
    /**
    * The number of entries to skip.
    */
    // @DataMember(Order=1)
    public skip?: number;

    /**
    * The number of entries to return.
    */
    // @DataMember(Order=2)
    public take?: number;

    public constructor(init?: Partial<ResearchApplicationGetCollection>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'ResearchApplicationGetCollection'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new ResearchApplicationCollectionResponse(); }
}

/**
* Form - ResearchApplication
*/
// @Route("/research-member-application/form/research-application/create", "POST")
// @Api(Description="Form - ResearchApplication")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Forms.Form.ResearchApplicationSingleResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Forms.Form.ResearchApplicationSingleResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Forms.Form.ResearchApplicationSingleResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Forms.Form.ResearchApplicationSingleResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Forms.Form.ResearchApplicationSingleResponse)", StatusCode=500)
// @DataContract
export class ResearchApplicationPostCreate implements IReturn<ResearchApplicationSingleResponse>
{
    [immerable] = true;
    /**
    * The metadata to use when creating the research application.
    */
    // @DataMember(Order=1)
    public metadata?: { [index: string]: Object; };

    /**
    * The values to prefill on the research application.
    */
    // @DataMember(Order=2)
    public data?: ResearchApplication;

    public constructor(init?: Partial<ResearchApplicationPostCreate>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'ResearchApplicationPostCreate'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new ResearchApplicationSingleResponse(); }
}

/**
* Form - ResearchApplication
*/
// @Route("/research-member-application/form/research-application/save", "POST")
// @Api(Description="Form - ResearchApplication")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Forms.Form.ResearchApplicationSingleResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Forms.Form.ResearchApplicationSingleResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Forms.Form.ResearchApplicationSingleResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Forms.Form.ResearchApplicationSingleResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Forms.Form.ResearchApplicationSingleResponse)", StatusCode=500)
// @DataContract
export class ResearchApplicationPostSave implements IReturn<ResearchApplicationSingleResponse>
{
    [immerable] = true;
    /**
    * The metadata to use when creating the research application.
    */
    // @DataMember(Order=1)
    public metadata?: { [index: string]: Object; };

    /**
    * The research application to save.
    */
    // @DataMember(Order=2)
    public data?: ResearchApplication;

    public constructor(init?: Partial<ResearchApplicationPostSave>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'ResearchApplicationPostSave'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ResearchApplicationSingleResponse(); }
}

/**
* Form - ResearchApplication
*/
// @Route("/research-member-application/form/research-application/validate", "POST")
// @Api(Description="Form - ResearchApplication")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Forms.Form.ResearchApplicationValidationResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Forms.Form.ResearchApplicationValidationResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Forms.Form.ResearchApplicationValidationResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Forms.Form.ResearchApplicationValidationResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Forms.Form.ResearchApplicationValidationResponse)", StatusCode=500)
// @DataContract
export class ResearchApplicationPostValidate implements IReturn<ResearchApplicationValidationResponse>
{
    [immerable] = true;
    /**
    * The metadata to use when validating the research application.
    */
    // @DataMember(Order=1)
    public metadata?: { [index: string]: Object; };

    /**
    * The research application to validate.
    */
    // @DataMember(Order=2)
    public data?: ResearchApplication;

    public constructor(init?: Partial<ResearchApplicationPostValidate>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'ResearchApplicationPostValidate'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ResearchApplicationValidationResponse(); }
}

// @Route("/research-member-application/file/view/{Id}", "GET")
export class GetFile implements IReturn<Blob>, IGet
{
    [immerable] = true;
    public id?: number;

    public constructor(init?: Partial<GetFile>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GetFile'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new Blob(); }
}

// @Route("/research-member-application/file/download/{Id}", "GET")
export class DownloadFile implements IReturn<Blob>, IGet
{
    [immerable] = true;
    public id?: number;

    public constructor(init?: Partial<DownloadFile>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'DownloadFile'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new Blob(); }
}

